export default "__VITE_ASSET__BfFNkp3C__"